export function groupSongVariations(songs) {
  const cards = [];
  const groups = new Map();

  songs.forEach((song) => {
    if (!song.sibling_group_id) {
      cards.push(song);
      return;
    }

    let group = groups.get(song.sibling_group_id);
    if (!group) {
      group = [];
      groups.set(song.sibling_group_id, group);
      cards.push({ __variationGroup: song.sibling_group_id, variations: group });
    }
    group.push(song);
  });

  return cards.map((card) => {
    if (!card.__variationGroup) return card;

    const variations = [...card.variations].sort((a, b) =>
      (a.track_number || 1) - (b.track_number || 1)
    );
    const primary = variations[0];

    return {
      ...primary,
      variations,
    };
  });
}
